module.exports = "/wwwroot/img/heart-solid.svg?ver=b30cd98f";